"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
////////////////////////////////////////////
const React = __importStar(require("react"));
const react_dom_1 = __importDefault(require("react-dom"));
const mui_1 = require("tss-react/mui");
const react_1 = require("@emotion/react");
const react_redux_1 = require("react-redux");
const immutable_1 = require("immutable");
const luxon_1 = require("luxon");
const crypto_js_1 = __importDefault(require("crypto-js"));
const uuid_1 = require("uuid");
const react_use_1 = require("react-use");
const Dialog_1 = __importDefault(require("@mui/material/Dialog"));
const Zoom_1 = __importDefault(require("@mui/material/Zoom"));
const Box_1 = __importDefault(require("@mui/material/Box"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const Build_1 = __importDefault(require("@mui/icons-material/Build"));
const Menu_1 = __importDefault(require("@mui/material/Menu"));
const MenuItem_1 = __importDefault(require("@mui/material/MenuItem"));
const Divider_1 = __importDefault(require("@mui/material/Divider"));
const ArrowDropDown_1 = __importDefault(require("@mui/icons-material/ArrowDropDown"));
const Radio_1 = __importDefault(require("@mui/material/Radio"));
const ListItem_1 = __importDefault(require("@mui/material/ListItem"));
const ListItemIcon_1 = __importDefault(require("@mui/material/ListItemIcon"));
const Clear_1 = __importDefault(require("@mui/icons-material/Clear"));
const ListItemText_1 = __importDefault(require("@mui/material/ListItemText"));
const ListItemSecondaryAction_1 = __importDefault(require("@mui/material/ListItemSecondaryAction"));
const Switch_1 = __importDefault(require("@mui/material/Switch"));
const TextField_1 = __importDefault(require("@mui/material/TextField"));
const Fab_1 = __importDefault(require("@mui/material/Fab"));
const core_1 = require("companion-app-components/utils/core");
const auth_1 = require("companion-app-components/flux/auth");
const profile_1 = require("companion-app-components/flux/profile");
const feature_flags_1 = require("companion-app-components/flux/feature-flags");
const accounts_1 = require("companion-app-components/flux/accounts");
const core_actions_1 = require("companion-app-components/flux/core-actions");
const nps_1 = require("companion-app-components/flux/nps");
const prefsActions = __importStar(require("companion-app-components/flux/preferences/actions"));
const entitlements_1 = require("companion-app-components/flux/entitlements");
const budgetsSelectors = __importStar(require("companion-app-components/flux/budgets/budgetsSelectors"));
const preferencesV2Actions_1 = require("companion-app-components/flux/preferences-v2/preferencesV2Actions");
const bump_1 = require("companion-app-components/flux/bump");
const redux_store_1 = __importDefault(require("companion-app-components/utils/redux-store"));
const immutableSerialize_1 = require("companion-app-components/utils/redux-store/immutableSerialize");
const preferencesV2Selectors_1 = require("companion-app-components/flux/preferences-v2/preferencesV2Selectors");
const preferencesV2Types_1 = require("companion-app-components/flux/preferences-v2/preferencesV2Types");
const root_ui_1 = require("companion-app-components/flux/root-ui");
const compose_1 = __importDefault(require("utils/compose"));
const notificationsUtils_1 = require("data/notifications/notificationsUtils");
const EmptyDialog_1 = require("components/Dialogs/EmptyDialog");
const RequestDialog_1 = __importDefault(require("components/RequestDialog"));
const HighlightText_1 = __importDefault(require("components/HighlightText"));
const NestedMenuItem_1 = __importDefault(require("components/QuickenControls/NestedMenuItem"));
const QDialogs_1 = __importDefault(require("components/QDialogs"));
const QSwitch_1 = __importDefault(require("components/QSwitch"));
const QButton_1 = __importDefault(require("components/QButton"));
const QPreferences_1 = __importDefault(require("components/QPreferences"));
const entitlementsActions = __importStar(require("data/entitlements/entitlementsActions"));
const helpers_1 = require("data/subscriptions/helpers");
const syncSentimentActions = __importStar(require("data/syncSentiment/syncSentimentActions"));
const QHelp_1 = __importDefault(require("components/QHelp"));
const utils_1 = require("utils/utils");
const subscriptionsTypes_1 = require("data/subscriptions/subscriptionsTypes");
const actions_1 = require("data/app/actions");
const subscriptionsSelectors = __importStar(require("data/subscriptions/subscriptionsSelectors"));
const useQPreferences_1 = __importDefault(require("components/QPreferences/useQPreferences"));
const consoleMirror_1 = __importDefault(require("utils/consoleMirror"));
const selectors_1 = require("data/app/selectors");
const selectorsProfile = __importStar(require("utils/selectorsProfile"));
const storeUtils_1 = require("utils/storeUtils");
const defaults_1 = require("data/preferences/defaults");
const sessionStorageEx = __importStar(require("utils/sessionStorageEx"));
const Main_1 = require("../Main");
const config_1 = require("../../SharedComponentsPage/config");
const ReusableComponentTag_1 = __importDefault(require("../../SharedComponentsPage/ReusableComponentTag"));
const investmentTransactions_1 = __importDefault(require("./investmentTransactions"));
const bankTransactions = __importStar(require("./bankTransactions"));
const logger = (0, core_1.getLogger)('DevMenu');
const styles = (_theme) => ({
    fullWidth: {
        width: '100%',
    },
});
const DevMenu = (props) => {
    var _a, _b, _c, _d, _f, _g, _h, _j, _k, _l;
    const { dialogAlert, setUserPreference, showQHelp, theme } = props;
    const dispatch = (0, react_redux_1.useDispatch)();
    const authSession = (0, react_redux_1.useSelector)(auth_1.authSelectors.getAuthSession);
    const datasetId = (0, react_redux_1.useSelector)(auth_1.authSelectors.getDatasetId);
    const profile = (0, react_redux_1.useSelector)(profile_1.profileSelectors.getProfile);
    const subscription = (0, react_redux_1.useSelector)(subscriptionsSelectors.getActiveSubscription); // FIXME
    const entitlement = (0, react_redux_1.useSelector)(entitlements_1.entitlementsSelectors.getTopTierEntitlement);
    const accounts = (0, react_redux_1.useSelector)(accounts_1.accountsSelectors.getAccountsById);
    const featureFlags = (0, react_redux_1.useSelector)(feature_flags_1.featureFlagsSelectors.getFeatureFlags);
    const entitlements = (0, react_redux_1.useSelector)(entitlements_1.entitlementsSelectors.getEntitlements);
    const preferencesV2 = (0, react_redux_1.useSelector)(preferencesV2Selectors_1.getPreferencesV2);
    const budgets = (0, react_redux_1.useSelector)(budgetsSelectors.getBudgets);
    const forceUpdate = (0, react_use_1.useUpdate)();
    const [openMenu, toggleMenu] = (0, react_use_1.useToggle)(false);
    const [simulateCrash, setSimulateCrash] = React.useState(false);
    const [showLoadDB, toggleLoadDB] = (0, react_use_1.useToggle)(false);
    const [showDevMenu, toggleDevMenu] = (0, react_use_1.useToggle)(true);
    const [featureFlagFilter, setFeatureFlagFilter] = React.useState('');
    const [preferenceSearchKey, setPreferenceSearchKey] = React.useState(undefined);
    const [datasetPreferenceSearchKey, setDatasetPreferenceSearchKey] = React.useState('');
    const [mcpTestMode, setMcpTestMode] = React.useState(core_1.localPreferences.getMCPTestMode() === 'true');
    const [requestData, setRequestData] = React.useState({
        showRequestDialog: false,
        requestMethod: 'GET',
        requestPath: '/accounts',
        requestQuery: { limit: 200 },
        requestBody: undefined,
    });
    const menuButtonRef = React.useRef();
    const { datasetPreferences, setDatasetPreference } = (0, useQPreferences_1.default)();
    const lastViewedBudgetId = (_a = datasetPreferences === null || datasetPreferences === void 0 ? void 0 : datasetPreferences.budgetOptions) === null || _a === void 0 ? void 0 : _a.lastViewedBudgetId;
    let budgetFullCalcPath = '/budget-calc';
    if (lastViewedBudgetId) {
        budgetFullCalcPath += `/${lastViewedBudgetId}/full`;
    }
    else if (!lastViewedBudgetId && (budgets === null || budgets === void 0 ? void 0 : budgets.size) >= 1) {
        budgetFullCalcPath += `/${budgets.keySeq().first()}/full`;
    }
    const storageEventListener = (event) => {
        if (event.key === 'budgetsEnabled'
            || event.key === 'subscriptionsOverride'
            || event.key === 'suppressWindowError'
            || event.key === 'suppressAssertPopups') {
            forceUpdate();
        }
    };
    (0, react_use_1.useMount)(() => {
        window.addEventListener('storage', storageEventListener);
    });
    const onTest = React.useCallback(() => {
        dispatch(root_ui_1.rootUiActions.createDialog(root_ui_1.rootUiTypes.mkRootUiData({
            id: 'login',
            type: EmptyDialog_1.DIALOG_TYPE_EMPTY_DIALOG,
            allowNesting: true,
            props: (0, immutable_1.Map)({
                title: 'login',
                maxWidth: 'lg',
                content: (<iframe name="auth" title="some title" width={800} height={720} src="http://localhost:3000/login"/>),
            }),
        })));
    }, [dispatch]);
    (0, react_use_1.useKey)((event) => event.ctrlKey && event.code === 'KeyT', onTest, { event: 'keypress' });
    (0, react_use_1.useKey)((event) => event.ctrlKey && event.code === 'KeyR', () => {
        var _a;
        const counter = ((_a = (0, selectors_1.getDBUpdateTrigger)(redux_store_1.default.getState())) !== null && _a !== void 0 ? _a : 0) + 1;
        redux_store_1.default === null || redux_store_1.default === void 0 ? void 0 : redux_store_1.default.dispatch((0, actions_1.setAppProps)({ dbUpdateTrigger: counter }));
        logger.debug(`trigger DB update (${counter})`);
    }, { event: 'keypress' });
    const onOpenMenu = (event) => {
        event.preventDefault();
        toggleMenu(!openMenu);
    };
    const onCloseMenu = () => {
        toggleMenu(false);
    };
    const dispatchUseRefreshToken = (data, meta) => dispatch(auth_1.authActions.exchangeRefreshToken(data, meta));
    const dispatchUpdateAuth = (data) => dispatch(auth_1.authActions.updateAuth(data));
    const onOverrideSubscriptionClick = (_event, productLineName, productLineUriName, tierName, expireAt) => {
        if (!productLineName) {
            core_1.localPreferences.removeItem('subscriptionsOverride');
        }
        else {
            const subscriptions = (0, helpers_1.getSubscriptionsOverride)() || [];
            let subscriptionData;
            if (Array.isArray(subscriptions)) {
                subscriptionData = subscriptions.find((obj) => obj.productLineName === productLineName);
            }
            if (subscriptionData) {
                subscriptions.splice(subscriptions.indexOf(subscriptionData), 1);
                if (!tierName) {
                    subscriptionData = undefined;
                }
            }
            else if (tierName) {
                subscriptionData = (0, subscriptionsTypes_1.mkSubscription)({ id: (0, uuid_1.v4)().toUpperCase(), productLineName, productLineUriName });
            }
            if (subscriptionData) {
                subscriptionData = subscriptionData.toJS();
                if (tierName) {
                    subscriptionData.tierName = tierName;
                }
                if (expireAt) {
                    subscriptionData.expireAt = expireAt;
                    subscriptionData.active = false;
                }
                else {
                    const expirationDate = new Date();
                    expirationDate.setFullYear(expirationDate.getFullYear() + 1);
                    subscriptionData.expireAt = expirationDate;
                    subscriptionData.active = true;
                }
                subscriptions.push(subscriptionData);
            }
            core_1.localPreferences.setItem('subscriptionsOverride', JSON.stringify(subscriptions));
        }
    };
    const clearAccountPreferences = () => {
        dialogAlert('You betta be sure Homey', 'This will CLEAR the color preferences, but not delete them because that is not supported by QCS', (btns) => {
            if (btns.btnPressed === 'I am VERY sure') {
                setDatasetPreference({ accountsPrefs: null });
            }
        }, ['I am VERY sure', 'I better ask Tim']);
        toggleMenu(false);
    };
    const clearWebAppPreferences = () => {
        dialogAlert('You betta be sure Homey', 'This will CLEAR ALL WEB APP PREFERENCES', (btns) => {
            if (btns.btnPressed === 'I am VERY sure') {
                // @ts-expect-error: resetAllPreferences requires args in newer types
                dispatch(prefsActions.resetAllPreferences());
            }
        }, ['I am VERY sure', 'I better ask Tim']);
        toggleMenu(false);
    };
    const resetWindowsReviewedPreference = () => {
        setUserPreference({ windowsReviewedWarningEnabled: true });
    };
    const corruptAccessToken = () => {
        dispatchUpdateAuth({ accessToken: 'corrupted!!!' });
    };
    const corruptRefreshToken = () => {
        dispatchUpdateAuth({ refreshToken: 'corrupted!!!' });
    };
    const corruptDatasetId = () => {
        dispatchUpdateAuth({ datasetId: 'corrupted!!!' });
    };
    const clearAccessToken = () => {
        dispatchUpdateAuth({
            accessToken: null,
            accessTokenExpired: null,
        });
    };
    const clearRefreshToken = () => {
        dispatchUpdateAuth({
            refreshToken: null,
            refreshTokenExpired: null,
        });
    };
    const clearDataset = () => {
        dispatchUpdateAuth({ datasetId: null });
    };
    const overrideEntitlement = (key, active) => {
        const localEntitlement = core_1.localPreferences.getItem('entitlementsOverride');
        const entitlementsData = localEntitlement ? JSON.parse(localEntitlement) : {};
        if (key === undefined) {
            core_1.localPreferences.removeItem('entitlementsOverride');
        }
        else {
            entitlementsData[key] = active;
        }
        core_1.localPreferences.setItem('entitlementsOverride', JSON.stringify(entitlementsData));
    };
    const subscriptionsOverride = (0, helpers_1.getSubscriptionsOverride)();
    const subscriptionOverrideUS = subscriptionsOverride ? subscriptionsOverride.find((subscriptionData) => subscriptionData.productLineName === 'Quicken US') : undefined;
    const subscriptionOverrideUSTierName = subscriptionOverrideUS ? subscriptionOverrideUS.tierName : undefined;
    const subscriptionOverrideCA = subscriptionsOverride ? subscriptionsOverride.find((subscriptionData) => subscriptionData.productLineName === 'Quicken Canada') : undefined;
    const subscriptionOverrideCATierName = subscriptionOverrideCA ? subscriptionOverrideCA.tierName : undefined;
    const suppressWindowError = core_1.localPreferences.getSuppressWindowError();
    const suppressAssertPopups = core_1.localPreferences.getSuppressAssertPopups();
    const disableBugsnag = core_1.localPreferences.getDisableBugsnag();
    const ignoreBugsnagReport = core_1.localPreferences.getIgnoreBugsnagReport();
    if (simulateCrash) {
        throw new Error('Simulate REACT unhandled exception!');
    }
    return (<div>
      {requestData.showRequestDialog && (<RequestDialog_1.default open={Boolean(requestData.showRequestDialog)} onHandleClose={() => setRequestData(Object.assign(Object.assign({}, requestData), { showRequestDialog: false }))} method={requestData.requestMethod} path={requestData.requestPath} query={requestData.requestQuery} body={requestData.requestBody}/>)}

      <Dialog_1.default open={Boolean(showLoadDB)} onClose={() => toggleLoadDB(false)}>
        <input style={{ margin: 40 }} id="file-input" type="file" onChange={(event) => {
            var _a, _b;
            const file = (_b = (_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.files) === null || _b === void 0 ? void 0 : _b[0];
            file === null || file === void 0 ? void 0 : file.text().then((json) => {
                const state = (0, immutableSerialize_1.hydrateImmutable)(json);
                redux_store_1.default === null || redux_store_1.default === void 0 ? void 0 : redux_store_1.default.dispatch(core_actions_1.coreActions.setRoot(state));
                toggleMenu(false);
                sessionStorageEx.setSandbox(true);
            });
        }}/>
      </Dialog_1.default>

      <Zoom_1.default in={showDevMenu}>
        <Fab_1.default sx={{
            all: 'unset',
            '&:hover, &:focus, &:active': {
                all: 'unset',
            },
        }} disableRipple disableFocusRipple>
          <IconButton_1.default id="dev-menu" ref={menuButtonRef} aria-label="DevMenu" role="complementary" style={{
            zIndex: 9999,
            margin: '10px',
            position: 'fixed',
            right: 0,
            bottom: 10,
            color: theme.palette.text.strong,
            opacity: 0.2,
        }} onClick={onOpenMenu} size="large">
            <Build_1.default />
            <ArrowDropDown_1.default style={{ transform: 'rotate(180deg)' }}/>
          </IconButton_1.default>
        </Fab_1.default>
      </Zoom_1.default>

      <Menu_1.default style={{ opacity: 0.85 }} open={openMenu} onClose={onCloseMenu} anchorEl={menuButtonRef.current} anchorOrigin={{ horizontal: 'left', vertical: 'top' }} transformOrigin={{ horizontal: 'left', vertical: 'bottom' }}>
        <NestedMenuItem_1.default key="Copy-User-Data-Menu" onClick={() => {
            toggleMenu(false);
            navigator.clipboard.writeText(`user id: ${authSession && authSession.qcsId}\n` +
                `dataset id: ${datasetId}\n` +
                `email: ${profile && profile.username}\n` +
                `subscription: ${subscription && subscription.productLineName} - ${subscription && subscription.tierName} (${subscription && subscription.expireOn})\n` +
                `entitlement: ${entitlement && entitlement.id} (${entitlement && entitlement.expiresOn})\n` +
                'accounts: \n' +
                `${accounts
                    .toIndexedSeq()
                    .sortBy((account) => account.name, (a, b) => a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' }))
                    .map((account, index) => `${index + 1}. ${account.name} (${account.id})`)
                    .join('\n')})\n`);
            (0, notificationsUtils_1.dispatchSimpleNotification)('User copied to clipboard');
        }} menuItems={[
            <MenuItem_1.default dense key="Save-DB" onClick={() => (0, storeUtils_1.saveStore)('store.json', false)}>
              Save DB
            </MenuItem_1.default>,
            <MenuItem_1.default dense key="Save-DB-Sanitized" onClick={() => (0, storeUtils_1.saveStore)('store.json', true)}>
              Save DB Sanitized
            </MenuItem_1.default>,
            <MenuItem_1.default dense key="Load-DB" onClick={() => {
                    toggleLoadDB(true);
                    toggleMenu(false);
                }}>
              Load DB
            </MenuItem_1.default>,
            <Divider_1.default />,
            <MenuItem_1.default dense key="copy-persistor-key" onClick={(event) => {
                    toggleMenu(false);
                    navigator.clipboard.writeText(crypto_js_1.default.SHA256(datasetId));
                    event.stopPropagation();
                }}>
              Copy Persistor Key
            </MenuItem_1.default>,
            <Divider_1.default />,
            <MenuItem_1.default dense key="Console-Logs" style={{ background: theme.palette.background.paper }} onClick={() => {
                    const logs = consoleMirror_1.default.log.reverse().join('\n');
                    alert(logs); // eslint-disable-line no-alert
                }}>
              Console Logs
            </MenuItem_1.default>,
        ]}>
          Copy User Data ({authSession && authSession.qcsId} - {datasetId})
        </NestedMenuItem_1.default>

        <Divider_1.default style={{ backgroundColor: theme.palette.background.elevated }}/>

        <NestedMenuItem_1.default style={{ opacity: 0.85, minWidth: '600px !important' }} key="FeatureFlagMenu" menuItems={[
            <MenuItem_1.default dense key="searchbar" style={{ minHeight: 60, background: theme.palette.background.paper }}>
              <TextField_1.default label="Type to Search" type="search" fullWidth autoFocus onChange={(event) => { var _a; return setFeatureFlagFilter((_a = event.target.value) === null || _a === void 0 ? void 0 : _a.toLowerCase()); }} onKeyDown={(event) => event.stopPropagation()} onKeyUp={(event) => event.stopPropagation()} onKeyPress={(event) => event.stopPropagation()}/>
            </MenuItem_1.default>,
            <Divider_1.default style={{ backgroundColor: theme.palette.background.elevated }}/>,
            ...featureFlags
                .filter((value, key) => !featureFlagFilter || (key === null || key === void 0 ? void 0 : key.toLowerCase().includes(featureFlagFilter)))
                .keySeq()
                .sort()
                .map((key) => (<MenuItem_1.default dense key={key} style={{ background: theme.palette.background.paper }}>
                  <ListItemText_1.default style={{ marginRight: 8 }} primary={<HighlightText_1.default text={key} searchKeys={[featureFlagFilter]}/>}/>
                  <TextField_1.default style={{ maxWidth: 96 }} value={String(featureFlags.get(key))} onChange={(event) => {
                    dispatch(feature_flags_1.featureFlagsActions.applyFeatureFlagsChanges({
                        [key]: event.target.value,
                    }));
                }} onKeyDown={(event) => event.stopPropagation()} onKeyUp={(event) => event.stopPropagation()}/>
                  <Switch_1.default size="small" color="primary" onChange={(event, value) => {
                    dispatch(feature_flags_1.featureFlagsActions.applyFeatureFlagsChanges({
                        [key]: value,
                    }));
                }} checked={Boolean(featureFlags.get(key))}/>
                </MenuItem_1.default>)),
        ]}>
          <ListItem_1.default component="div" key="feature-flag-toggler">
            <ListItemText_1.default primary={`Feature Flags (${((_b = (0, core_1.getBuildConfig)()) === null || _b === void 0 ? void 0 : _b.ld_client_id) === '5b4cfcd09dc3df2d8d0d471c' ? 'prod' : ''}${((_c = (0, core_1.getBuildConfig)()) === null || _c === void 0 ? void 0 : _c.ld_client_id) === '5b4cfcd09dc3df2d8d0d471b' ? 'dev' : ''} - ${(_d = (0, core_1.getBuildConfig)()) === null || _d === void 0 ? void 0 : _d.ld_client_id})`}/>
            <Switch_1.default size="small" color="primary" onChange={(_event, value) => {
            core_1.localPreferences.setFeatureFlagsFreeze(!value);
            forceUpdate();
        }} checked={!core_1.localPreferences.getFeatureFlagsFreeze()}/>
          </ListItem_1.default>
        </NestedMenuItem_1.default>

        <Divider_1.default />

        <NestedMenuItem_1.default onKeyDown={(event) => event.stopPropagation()} onKeyUp={(event) => event.stopPropagation()} onKeyPress={(event) => event.stopPropagation()} menuItems={[
            <MenuItem_1.default dense key="searchbar">
              <TextField_1.default label="Type to Search" type="search" fullWidth autoFocus onChange={(event) => { var _a; return setPreferenceSearchKey((_a = event.target.value) === null || _a === void 0 ? void 0 : _a.toLowerCase()); }}/>
            </MenuItem_1.default>,
            <Divider_1.default />,
            preferencesV2
                .filter((preference) => {
                var _a, _b, _c;
                return !preferenceSearchKey ||
                    ((_a = preference.label) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(preferenceSearchKey)) ||
                    ((_b = preference.name) === null || _b === void 0 ? void 0 : _b.toLowerCase().includes(preferenceSearchKey)) ||
                    ((_c = preference.value) === null || _c === void 0 ? void 0 : _c.toLowerCase().includes(preferenceSearchKey));
            })
                .valueSeq()
                .sort((preference1, preference2) => { var _a; return (_a = preference1.label) === null || _a === void 0 ? void 0 : _a.localeCompare(preference2.label); })
                .map((preference) => (<MenuItem_1.default dense key={preference.id}>
                  <Box_1.default display="flex" alignItems="center" justifyContent="flex-end" width="100%">
                    <HighlightText_1.default text={`${preference.label} (${preference.name})`} searchKeys={[preferenceSearchKey]}/>
                    &nbsp;&nbsp;&nbsp;
                    <TextField_1.default defaultValue={preference.value} onBlur={(event) => {
                    if (preference.value !== event.target.value) {
                        dispatch((0, preferencesV2Actions_1.updatePreferenceCriteria)(
                        // @ts-expect-error: mkPreferenceCriteria arg type mismatch; datasetId may be undefined
                        (0, preferencesV2Types_1.mkPreferenceCriteria)({
                            preferenceName: preference.name,
                            value: event.target.value,
                            rollOutTarget: [datasetId],
                            criteriaType: 'DATASET_ID',
                            rollOutType: 'INDIVIDUAL',
                        }), { undo: { userMessage: `Preference "${preference.label}" updated.` } }));
                    }
                }} onKeyDown={(event) => {
                    if (event.key === 'Enter') {
                        const inputElement = event.target;
                        inputElement.blur();
                    }
                }}/>
                    <IconButton_1.default size="small" onClick={() => {
                    // TODO: delete criteria
                }}>
                      <Clear_1.default />
                    </IconButton_1.default>
                  </Box_1.default>
                </MenuItem_1.default>)),
            <Divider_1.default />,
        ]}>
          Preferences
        </NestedMenuItem_1.default>

        <Divider_1.default />

        <NestedMenuItem_1.default onKeyDown={(event) => event.stopPropagation()} onKeyUp={(event) => event.stopPropagation()} onKeyPress={(event) => event.stopPropagation()} menuItems={[
            <MenuItem_1.default dense key="dataset-prefs-searchbar">
              <TextField_1.default label="Type to Search" type="search" fullWidth autoFocus onChange={(event) => setDatasetPreferenceSearchKey(event.target.value)}/>
            </MenuItem_1.default>,
            <Divider_1.default />,
            <MenuItem_1.default key={'reset-dataset-preferences'} dense>
              <QButton_1.default variant="delete" onClick={() => setDatasetPreference(Object.assign({}, defaults_1.defaultDatasetPreferences))}>
                RESET TO DEFAULT DATASET PREFERENCES
              </QButton_1.default>
            </MenuItem_1.default>,
            <Divider_1.default />,
            ...Object.entries(datasetPreferences)
                .filter(([prefKey]) => !datasetPreferenceSearchKey || prefKey.includes(datasetPreferenceSearchKey))
                .sort(([aKey], [bKey]) => aKey.localeCompare(bKey))
                .map(([prefKey, prefValue]) => {
                let updater;
                switch (typeof prefValue) {
                    case 'boolean':
                        updater = <QSwitch_1.default checked={Boolean(prefValue)} onChange={() => setDatasetPreference({ [prefKey]: !prefValue })}/>;
                        break;
                    case 'string':
                        updater = <span>&quot;{prefValue}&quot;</span>;
                        break;
                    default:
                        updater = <span>can&apos;t be edited yet</span>;
                        break;
                }
                return (<MenuItem_1.default dense>
                    <Box_1.default width="100%" display="flex" alignItems="center">
                      <span style={{ flex: 1 }}>{prefKey}:</span>
                      {updater}
                    </Box_1.default>
                    <Divider_1.default />
                  </MenuItem_1.default>);
            }),
        ]}>
          Dataset Preferences
        </NestedMenuItem_1.default>

        <Divider_1.default />

        <NestedMenuItem_1.default dense id="request-menu" onClick={(event) => {
            if (event.target === event.currentTarget) {
                setRequestData(Object.assign(Object.assign({}, requestData), { showRequestDialog: true }));
            }
        }} menuItems={[
            <NestedMenuItem_1.default id="qcs-web-socket-menu" dense menuItems={[
                    <MenuItem_1.default id="custom" dense onClick={(event) => {
                            event.stopPropagation();
                            dispatch(bump_1.bumpActions.sendBumpMessage({
                                hello: 'world',
                            }));
                        }}>
                  Custom Message
                </MenuItem_1.default>,
                ]}>
              QCS web socket
            </NestedMenuItem_1.default>,
            <Divider_1.default />,
            <NestedMenuItem_1.default id="inject-transactions" dense menuItems={[
                    <MenuItem_1.default id="inject-investment-transactions" dense onClick={(event) => {
                            event.stopPropagation();
                            const account = accounts_1.accountsSelectors.getInvestmentAccounts(redux_store_1.default.getState()).first();
                            setRequestData({
                                showRequestDialog: true,
                                requestMethod: 'POST',
                                requestPath: '/transactions/test-aggregated-importer',
                                requestQuery: undefined,
                                requestBody: JSON.stringify({
                                    inTesting: true,
                                    accountId: account === null || account === void 0 ? void 0 : account.id,
                                    pendingAggregationType: 'CURRENT_PENDING_LIST',
                                    transactions: (0, investmentTransactions_1.default)(account),
                                    cpData: {
                                        balance: 2000.01,
                                        balanceAt: luxon_1.DateTime.local().toISO(),
                                    },
                                }, null, 2),
                            });
                        }}>
                  Inject Investment Transaction
                </MenuItem_1.default>,
                    <MenuItem_1.default id="inject-transaction-pending" dense onClick={(event) => {
                            event.stopPropagation();
                            setRequestData({
                                showRequestDialog: true,
                                requestMethod: 'POST',
                                requestPath: '/transactions/test-aggregated-importer',
                                requestQuery: undefined,
                                requestBody: JSON.stringify(bankTransactions.getPendingTransactionMockData(), null, 2),
                            });
                        }}>
                  Inject Pending Transaction
                </MenuItem_1.default>,
                    <MenuItem_1.default id="inject-posted-transaction" dense onClick={(event) => {
                            event.stopPropagation();
                            setRequestData({
                                showRequestDialog: true,
                                requestMethod: 'POST',
                                requestPath: '/transactions/test-aggregated-importer',
                                requestQuery: undefined,
                                requestBody: JSON.stringify(bankTransactions.getPostedTransactionMockData(), null, 2),
                            });
                        }}>
                  Inject Posted Transaction
                </MenuItem_1.default>,
                ]}>
              Inject Transaction
            </NestedMenuItem_1.default>,
            <Divider_1.default />,
            <MenuItem_1.default id="delete-dataset" dense onClick={(event) => {
                    event.stopPropagation();
                    setRequestData({
                        showRequestDialog: true,
                        requestMethod: 'DELETE',
                        requestPath: `/datasets/${datasetId}`,
                        requestQuery: undefined,
                        requestBody: undefined,
                    });
                }}>
              Delete Dataset
            </MenuItem_1.default>,
            <Divider_1.default />,
            <NestedMenuItem_1.default dense menuItems={[
                    <MenuItem_1.default id="get-all" dense onClick={() => {
                            setRequestData({
                                showRequestDialog: true,
                                requestMethod: 'GET',
                                requestPath: '/accounts',
                                requestQuery: undefined,
                                requestBody: undefined,
                            });
                        }}>
                  Get All
                </MenuItem_1.default>,
                ]}>
              Accounts
            </NestedMenuItem_1.default>,
            <NestedMenuItem_1.default id="alerts-menu" dense menuItems={[
                    <MenuItem_1.default id="alerts-all" dense onClick={(event) => {
                            event.stopPropagation();
                            setRequestData({
                                showRequestDialog: true,
                                requestMethod: 'GET',
                                requestPath: '/institution-logins/clear-aasr',
                                requestQuery: undefined,
                                requestBody: undefined,
                            });
                        }}>
                  Clear AASR
                </MenuItem_1.default>,
                ]}>
              Institution Logins
            </NestedMenuItem_1.default>,
            <MenuItem_1.default onClick={(event) => {
                    event.stopPropagation();
                    setRequestData({
                        showRequestDialog: true,
                        requestMethod: 'GET',
                        requestPath: '/preferences/user',
                        requestQuery: undefined,
                        requestBody: undefined,
                    });
                }}>
              User Preferences
            </MenuItem_1.default>,
            <MenuItem_1.default onClick={(event) => {
                    event.stopPropagation();
                    setRequestData({
                        showRequestDialog: true,
                        requestMethod: 'GET',
                        requestPath: '/preferences',
                        requestQuery: undefined,
                        requestBody: undefined,
                    });
                }}>
              Dataset Preferences
            </MenuItem_1.default>,
            <MenuItem_1.default onClick={(event) => {
                    event.stopPropagation();
                    setRequestData({
                        showRequestDialog: true,
                        requestMethod: 'GET',
                        requestPath: budgetFullCalcPath,
                        requestQuery: undefined,
                        requestBody: undefined,
                    });
                }}>
              Budget force calc
            </MenuItem_1.default>,
        ]}>
          Request
        </NestedMenuItem_1.default>

        <Divider_1.default />

        <MenuItem_1.default onClick={() => {
            config_1.LIST_OF_COMPONENT_IDS.forEach((id) => {
                const elements = document.querySelectorAll(`[sharedcomponentid="${id}"]`);
                elements.forEach((node) => {
                    var _a;
                    if (((_a = window.getComputedStyle(node)) === null || _a === void 0 ? void 0 : _a.position) === 'static') {
                        node.style.position = 'relative'; // eslint-disable-line
                    }
                    const anchorElement = document.createElement('div');
                    node.appendChild(anchorElement);
                    // eslint-disable-next-line react/no-deprecated
                    react_dom_1.default.render(React.createElement(ReusableComponentTag_1.default, { id }), anchorElement);
                });
            });
            onCloseMenu();
        }} dense>
          Find Shared Components
        </MenuItem_1.default>

        <Divider_1.default />

        <NestedMenuItem_1.default key="Why-Did-You-Render-Menu" menuItems={Object.entries(core_1.localPreferences.getWDYRSettings()).map(([key, value]) => (<ListItem_1.default component="div" key={key}>
              <ListItemText_1.default primary={key}/>
              <Switch_1.default size="small" color="primary" onChange={(_event, newValue) => {
                core_1.localPreferences.setWDYRSettings(Object.assign(Object.assign({}, core_1.localPreferences.getWDYRSettings()), { [key]: newValue }));
                forceUpdate();
            }} checked={Boolean(value)} onClick={(event) => event.stopPropagation()}/>
            </ListItem_1.default>))}>
          <ListItem_1.default component="div" key="why-render">
            <ListItemIcon_1.default>
              <IconButton_1.default size="small" onClick={() => {
            core_1.localPreferences.setWDYRSettings(undefined);
            forceUpdate();
        }}>
                <Clear_1.default />
              </IconButton_1.default>
            </ListItemIcon_1.default>
            <ListItemText_1.default primary="Why Did You Render? (ctrl + r)"/>
            <Switch_1.default size="small" color="primary" onChange={(_event, value) => {
            core_1.localPreferences.setWhyDidYouRender(value);
            forceUpdate();
        }} checked={core_1.localPreferences.getWhyDidYouRender()} onClick={(event) => event.stopPropagation()}/>
          </ListItem_1.default>
        </NestedMenuItem_1.default>

        <Divider_1.default />

        <MenuItem_1.default>
          <ListItem_1.default component="div" onClick={() => {
            const profileData = selectorsProfile.getItems();
            // eslint-disable-next-line no-console
            console.table(Object.fromEntries(profileData));
            forceUpdate();
        }}>
            <ListItemIcon_1.default>
              <IconButton_1.default size="small" onClick={() => {
            selectorsProfile.clear();
            forceUpdate();
        }}>
                <Clear_1.default />
              </IconButton_1.default>
            </ListItemIcon_1.default>
            <ListItemText_1.default primary={`Profile Selectors (${selectorsProfile.getItems().size})`}/>
            <Switch_1.default size="small" color="primary" onChange={(_event, value) => {
            core_1.localPreferences.setSelectorsProfiling(value);
            forceUpdate();
        }} checked={core_1.localPreferences.getSelectorsProfiling()} onClick={(event) => event.stopPropagation()}/>
          </ListItem_1.default>
        </MenuItem_1.default>

        <Divider_1.default />

        <NestedMenuItem_1.default key="Crash-Menu" style={{ opacity: 0.85 }} menuItems={[
            <MenuItem_1.default dense key="simulate-JS" onClick={() => {
                    throw new Error('Simulate JS unhandled exception!');
                }}>
              Simulate JS unhandled exception
            </MenuItem_1.default>,
            <MenuItem_1.default dense key="simulate-REACT" onClick={() => {
                    setSimulateCrash(true);
                }}>
              Simulate REACT unhandled exception
            </MenuItem_1.default>,
            <MenuItem_1.default dense key="simulate-JS-handled" onClick={() => {
                    try {
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        null.simulateHandledException();
                    }
                    catch (e) {
                        core_1.crashReporterInterface.reportError(e, (event) => event.addMetadata('custom', { some: 'data' }));
                    }
                }}>
              Simulate JS handled exception
            </MenuItem_1.default>,
            <MenuItem_1.default dense key="simulate-unhandled-rejection" onClick={() => {
                    const promise = new Promise((_resolve, reject) => {
                        reject(Error('simulate unhandled rejection'));
                    });
                    promise.then(() => logger.debug('promiss fulfilled'));
                }}>
              Simulate unhandled rejection
            </MenuItem_1.default>,
            <MenuItem_1.default dense key="simulate-user-agent-error" onClick={() => {
                    Object.defineProperty(navigator, 'userAgent', {
                        value: 'hello',
                        configurable: false,
                    });
                    // TypeError: Cannot redefine property: userAgent
                    Object.defineProperty(navigator, 'userAgent', {
                        value: 'world',
                    });
                }}>
              Simulate userAgent exception
            </MenuItem_1.default>,
            <MenuItem_1.default dense key="simulate-assert1" onClick={() => {
                    assert(false, 'test assert1');
                }}>
              Simulate assert1
            </MenuItem_1.default>,
            <MenuItem_1.default dense key="simulate-assert2" onClick={() => {
                    assert(false, 'test assert2');
                }}>
              Simulate assert2
            </MenuItem_1.default>,
            <MenuItem_1.default dense key="simulate-verify" onClick={() => {
                    verify(false, 'test verify');
                }}>
              Simulate verify
            </MenuItem_1.default>,
            <MenuItem_1.default dense key="simulate-local-storage-full" onClick={() => {
                    const pattern = 'full of junk full of junk full of junk full of junk full of junk full of junk full of junk';
                    try {
                        for (let index = 1; true; index++) { // eslint-disable-line no-constant-condition
                            localStorage.setItem(`${index}`, pattern);
                        }
                    }
                    catch (_e) {
                        try {
                            for (let length = 0; length < pattern.length; length++) { // eslint-disable-line no-constant-condition
                                localStorage.setItem('0', pattern.slice(0, length));
                            }
                        }
                        catch (e) {
                            assert(false, e);
                        }
                    }
                }}>
              Simulate localStorage full
            </MenuItem_1.default>,
            <MenuItem_1.default dense key="suppress-window">
              <ListItemText_1.default primary="Suppress Error Alert (show Uh Oh page)"/>
              <Switch_1.default size="small" color="primary" onChange={() => {
                    core_1.localPreferences.setSuppressWindowError(!suppressWindowError);
                    forceUpdate();
                }} checked={suppressWindowError}/>
            </MenuItem_1.default>,
            <MenuItem_1.default dense key="disable-bugsnag">
              <ListItemText_1.default primary="Disable Bugsnag (restart required)"/>
              <Switch_1.default size="small" color="primary" onChange={() => {
                    core_1.localPreferences.setDisableBugsnag(!disableBugsnag);
                    forceUpdate();
                }} checked={disableBugsnag}/>
            </MenuItem_1.default>,
            <MenuItem_1.default dense key="ignore-bugsnag">
              <ListItemText_1.default primary="Ignore Bugsnag Reports"/>
              <Switch_1.default size="small" color="primary" onChange={() => {
                    core_1.localPreferences.setIgnoreBugsnagReport(!ignoreBugsnagReport);
                    forceUpdate();
                }} checked={ignoreBugsnagReport}/>
            </MenuItem_1.default>,
            <MenuItem_1.default dense key="suppress-assert" style={{ background: theme.palette.background.paper }}>
              <ListItemText_1.default primary="Suppress Asserts"/>
              <Switch_1.default size="small" color="primary" onChange={() => {
                    core_1.localPreferences.setSuppressAssertPopups(!suppressAssertPopups);
                    forceUpdate();
                }} checked={suppressAssertPopups}/>
            </MenuItem_1.default>,
        ]}>
          Crash ({(_f = (0, core_1.getBuildConfig)()) === null || _f === void 0 ? void 0 : _f.bugsnag_release_stage} - {(_g = (0, core_1.getBuildConfig)()) === null || _g === void 0 ? void 0 : _g.bugsnag_api_key})
        </NestedMenuItem_1.default>

        <Divider_1.default style={{ backgroundColor: theme.palette.background.elevated }}/>
        <NestedMenuItem_1.default key="Tracking-Menu" style={{ opacity: 0.85 }} menuItems={[
            <MenuItem_1.default dense key="track-user" style={{ background: theme.palette.background.paper }} onClick={() => {
                    core_1.tracker.trackActive();
                    toggleMenu(false);
                }}>
              Track Active User
            </MenuItem_1.default>,
            <MenuItem_1.default dense key="track-user-forced" style={{ background: theme.palette.background.paper }} onClick={() => {
                    core_1.tracker.track(core_1.tracker.events.active);
                    toggleMenu(false);
                }}>
              Track Active User (forced)
            </MenuItem_1.default>,
        ]}>
          {`Tracking (${(((_h = (0, core_1.getBuildConfig)()) === null || _h === void 0 ? void 0 : _h.mixpanel_token) === 'aa163a00ce018fca28d192192ed4de8b' && 'prod') ||
            (((_j = (0, core_1.getBuildConfig)()) === null || _j === void 0 ? void 0 : _j.mixpanel_token) === 'f02e19059c63af74c567d59435e16a1d' && 'dev')} - ${(_k = (0, core_1.getBuildConfig)()) === null || _k === void 0 ? void 0 : _k.mixpanel_token})`}
        </NestedMenuItem_1.default>
        <Divider_1.default style={{ backgroundColor: theme.palette.background.elevated }}/>

        <NestedMenuItem_1.default key="subscriptions-menu" style={{ opacity: 0.85 }} menuItems={[
            <MenuItem_1.default dense key="use-real-subscription" style={{ background: theme.palette.background.paper }} onClick={(event) => onOverrideSubscriptionClick(event, undefined, undefined, undefined, undefined)}>
              {!subscriptionsOverride ? '[x]' : '[ ]'} Use real subscription
            </MenuItem_1.default>,
            <Divider_1.default style={{ backgroundColor: theme.palette.background.elevated }}/>,
            <MenuItem_1.default dense key="override-US-subscription" style={{ background: theme.palette.background.paper }} disabled>
              Override US Subscription
            </MenuItem_1.default>,
            <MenuItem_1.default dense key="Starter-US" style={{ background: theme.palette.background.paper }} onClick={(event) => onOverrideSubscriptionClick(event, 'Quicken US', 'quicken-us', 'Starter', undefined)}>
              {subscriptionOverrideUSTierName === 'Starter' ? '[x]' : '[ ]'} Starter US
            </MenuItem_1.default>,
            <MenuItem_1.default dense key="deluxe-US" style={{ background: theme.palette.background.paper }} onClick={(event) => onOverrideSubscriptionClick(event, 'Quicken US', 'quicken-us', 'Deluxe', undefined)}>
              {subscriptionOverrideUSTierName === 'Deluxe' ? '[x]' : '[ ]'} Deluxe US
            </MenuItem_1.default>,
            <MenuItem_1.default dense key="premier-US" style={{ background: theme.palette.background.paper }} onClick={(event) => onOverrideSubscriptionClick(event, 'Quicken US', 'quicken-us', 'Premier', undefined)}>
              {subscriptionOverrideUSTierName === 'Premier' ? '[x]' : '[ ]'} Premier US
            </MenuItem_1.default>,
            <MenuItem_1.default dense key="home-business-rental-US" style={{ background: theme.palette.background.paper }} onClick={(event) => {
                    onOverrideSubscriptionClick(event, 'Quicken US', 'quicken-us', 'Home, Business & Rental Property', undefined);
                }}>
              {subscriptionOverrideUSTierName === 'Home, Business & Rental Property' ? '[x]' : '[ ]'} Home, Business & Rental
              Property US
            </MenuItem_1.default>,
            <MenuItem_1.default dense key="no-US-subscription" style={{ background: theme.palette.background.paper }} onClick={(event) => onOverrideSubscriptionClick(event, 'Quicken US', 'quicken-us', undefined, undefined)}>
              {!subscriptionOverrideUS ? '[x]' : '[ ]'} no US subscription
            </MenuItem_1.default>,
            <Divider_1.default style={{ backgroundColor: theme.palette.background.elevated }}/>,
            <MenuItem_1.default dense key="Quicken-expired-US" style={{ background: theme.palette.background.paper }} onClick={(event) => onOverrideSubscriptionClick(event, 'Quicken US', 'quicken-us', undefined, new Date())}>
              expire US subscription
            </MenuItem_1.default>,
            <Divider_1.default style={{ backgroundColor: theme.palette.background.elevated }}/>,
            <MenuItem_1.default dense key="override-CA-Subscription" style={{ background: theme.palette.background.paper }} disabled>
              Override CA Subscription
            </MenuItem_1.default>,
            <MenuItem_1.default dense key="Quicken-starter-canada" style={{ background: theme.palette.background.paper }} onClick={(event) => onOverrideSubscriptionClick(event, 'Quicken Canada', 'quicken-ca', 'Starter', undefined)}>
              {subscriptionOverrideCATierName === 'Starter' ? '[x]' : '[ ]'} Starter CA
            </MenuItem_1.default>,
            <MenuItem_1.default dense key="Quicken-Canada-Deluxe" style={{ background: theme.palette.background.paper }} onClick={(event) => onOverrideSubscriptionClick(event, 'Quicken Canada', 'quicken-ca', 'Deluxe', undefined)}>
              {subscriptionOverrideCATierName === 'Deluxe' ? '[x]' : '[ ]'} Deluxe CA
            </MenuItem_1.default>,
            <MenuItem_1.default dense key="Quicken-canada-home-and-business" style={{ background: theme.palette.background.paper }} onClick={(event) => {
                    onOverrideSubscriptionClick(event, 'Quicken Canada', 'quicken-ca', 'Home and Business', undefined);
                }}>
              {subscriptionOverrideCATierName === 'Home and Business' ? '[x]' : '[ ]'} Home and Business CA
            </MenuItem_1.default>,
            <MenuItem_1.default dense key="Quicken-no-subscription-canada" style={{ background: theme.palette.background.paper }} onClick={(event) => onOverrideSubscriptionClick(event, 'Quicken Canada', 'quicken-ca', undefined, undefined)}>
              {!subscriptionOverrideCA ? '[x]' : '[ ]'} no CA subscription
            </MenuItem_1.default>,
            <Divider_1.default style={{ backgroundColor: theme.palette.background.elevated }}/>,
            <MenuItem_1.default dense key="Quicken-expired-canada" style={{ background: theme.palette.background.paper }} onClick={(event) => onOverrideSubscriptionClick(event, 'Quicken Canada', 'quicken-ca', undefined, new Date())}>
              expire CA subscription
            </MenuItem_1.default>,
            <Divider_1.default style={{ backgroundColor: theme.palette.background.elevated }}/>,
        ]}>
          subscriptions
        </NestedMenuItem_1.default>

        <NestedMenuItem_1.default key="entitlements-menu" style={{ opacity: 0.85 }} menuItems={[
            <MenuItem_1.default dense key="use-real-entitles" style={{ background: theme.palette.background.paper }}>
              <ListItemText_1.default primary="Use real entitlements"/>
              <Switch_1.default size="small" color="primary" onChange={() => core_1.localPreferences.removeItem('entitlementsOverride')} checked={Boolean(!core_1.localPreferences.getItem('entitlementsOverride'))}/>
            </MenuItem_1.default>,
            <Divider_1.default />,
            ...[
                { id: 'US_QUICKEN_STARTER', label: 'US_QUICKEN_STARTER' },
                { id: 'US_QUICKEN_DELUXE', label: 'US_QUICKEN_DELUXE' },
                { id: 'US_QUICKEN_PREMIER', label: 'US_QUICKEN_PREMIER' },
                { id: 'US_QUICKEN_HABRPM', label: 'US_QUICKEN_HABRPM' },
                { id: 'CA_QUICKEN_CASHMANAGER', label: 'CA_QUICKEN_CASHMANAGER' },
                { id: 'CA_QUICKEN_DELUXE', label: 'CA_QUICKEN_DELUXE' },
                { id: 'CA_QUICKEN_HAB', label: 'CA_QUICKEN_HAB' },
                { id: 'PREMIUM_SUPPORT', label: 'PREMIUM_SUPPORT' },
                { id: 'FREE_QUICKEN_BILLPAY', label: 'FREE_QUICKEN_BILLPAY' },
                { id: 'US_QUICKEN_CFOE', label: 'US_QUICKEN_CFOE' },
            ].map(({ id, label }) => (<MenuItem_1.default dense style={{ background: theme.palette.background.paper }} key={label}>
                <ListItemText_1.default primary={label}/>
                <Switch_1.default size="small" color="primary" onChange={(event, value) => {
                    overrideEntitlement(id, value);
                    const expiresOn = value ? luxon_1.DateTime.local().plus({ years: 1 }).toISODate() : luxon_1.DateTime.local().toISODate();
                    const expiresAt = value ? luxon_1.DateTime.local().plus({ years: 1 }).toISO() : luxon_1.DateTime.local().toISO();
                    dispatch(entitlementsActions.setEntitlement(
                    // @ts-expect-error: mkEntitlement result type mismatch with setEntitlement arg
                    entitlements_1.entitlementsTypes.mkEntitlement({
                        id,
                        active: value,
                        expiresOn: expiresOn !== null && expiresOn !== void 0 ? expiresOn : undefined,
                        expiresAt: expiresAt !== null && expiresAt !== void 0 ? expiresAt : undefined,
                    })));
                }} checked={Boolean((entitlements.get(id) || {}).active)}/>
              </MenuItem_1.default>)),
        ]}>
          entitlements
        </NestedMenuItem_1.default>
        <Divider_1.default style={{ backgroundColor: theme.palette.background.elevated }}/>
        <NestedMenuItem_1.default key="auth-menu" style={{ opacity: 0.85 }} id="auth-menu" arrowid="auth-menu-arrow" menuItems={[
            <MenuItem_1.default dense key="clear-access-token-key" style={{ background: theme.palette.background.paper }} id="clear-access-token" onClick={() => clearAccessToken()}>
              Clear access token -&nbsp;
              <span style={{ display: 'inline-block', width: 300, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {authSession.accessToken}
              </span>
            </MenuItem_1.default>,
            <MenuItem_1.default dense key="clear-refresh-token-key" style={{ background: theme.palette.background.paper }} id="clear-refresh-token" onClick={() => clearRefreshToken()}>
              Clear refresh token -&nbsp;
              <span style={{ display: 'inline-block', width: 300, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {authSession.refreshToken}
              </span>
            </MenuItem_1.default>,
            <MenuItem_1.default dense key="clear-dataset-key" style={{ background: theme.palette.background.paper }} id="clear-dataset" onClick={() => clearDataset()}>
              Clear dataset -&nbsp;
              <span style={{ display: 'inline-block', width: 300, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {authSession.datasetId}
              </span>
            </MenuItem_1.default>,
            <Divider_1.default style={{ backgroundColor: theme.palette.background.elevated }}/>,
            <MenuItem_1.default dense key="expire-access-token-key" style={{ background: theme.palette.background.paper }} id="expire-access-token" onClick={() => dispatch(auth_1.authActions.invalidateAccessToken())}>
              Expire access token ({luxon_1.DateTime.fromISO(authSession.accessTokenExpired).toLocaleString(luxon_1.DateTime.DATETIME_MED)})
            </MenuItem_1.default>,
            <MenuItem_1.default dense key="expire-refresh-token-key" style={{ background: theme.palette.background.paper }} id="expire-refresh-token" onClick={() => {
                    dispatch(auth_1.authActions.invalidateRefreshToken());
                }}>
              Expire refresh token ({luxon_1.DateTime.fromISO(authSession.refreshTokenExpired).toLocaleString(luxon_1.DateTime.DATETIME_MED)})
            </MenuItem_1.default>,
            <Divider_1.default style={{ backgroundColor: theme.palette.background.elevated }}/>,
            <MenuItem_1.default dense key="corrupt-access-token-key" style={{ background: theme.palette.background.paper }} id="corrupt-access-token" onClick={() => corruptAccessToken()}>
              Corrupt access token -&nbsp;
              <span style={{ display: 'inline-block', width: 300, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {authSession.accessToken}
              </span>
            </MenuItem_1.default>,
            <MenuItem_1.default dense key="corrupt-refresh-token-key" style={{ background: theme.palette.background.paper }} id="corrupt-refresh-token" onClick={() => corruptRefreshToken()}>
              Corrupt refresh token -&nbsp;
              <span style={{ display: 'inline-block', width: 300, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {authSession.refreshToken}
              </span>
            </MenuItem_1.default>,
            <MenuItem_1.default dense key="corrupt-dataset-key" id="corrupt-dataset" onClick={() => corruptDatasetId()}>
              Corrupt data set ({authSession.datasetId})
            </MenuItem_1.default>,
            <MenuItem_1.default dense key="not-existing-dataset-key" id="no-existing-dataset" onClick={() => dispatchUpdateAuth({ datasetId: '12345' })}>
              Set not existing data set ({authSession.datasetId})
            </MenuItem_1.default>,
            <Divider_1.default />,
            <MenuItem_1.default dense key="use-refresh-token" id="use-refresh-token" onClick={() => dispatchUseRefreshToken()}>
              Use Refresh Token&nbsp;
              <span style={{ display: 'inline-block', width: 300, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                ({authSession.refreshToken})
              </span>
            </MenuItem_1.default>,
        ]}>
          auth
        </NestedMenuItem_1.default>

        <Divider_1.default style={{ backgroundColor: theme.palette.background.elevated }}/>
        <NestedMenuItem_1.default key="NPS-menu" style={{ opacity: 0.85 }} menuItems={[
            <MenuItem_1.default dense key="survey-request" style={{ background: theme.palette.background.paper }}>
              <ListItemText_1.default primary="Survey Requested"/>
              <Switch_1.default size="small" color="primary" disabled={!authSession} onChange={(event, value) => {
                    dispatchUpdateAuth({ surveyRequested: value });
                }} checked={Boolean(authSession && authSession.surveyRequested)}/>
            </MenuItem_1.default>,
            <MenuItem_1.default dense key="check-for-survey" style={{ background: theme.palette.background.paper }} onClick={() => dispatch(nps_1.npsActions.checkIfNPSSurveyRequestedAction())}>
              Check for Survey Now
            </MenuItem_1.default>,
        ]}>
          NPS
        </NestedMenuItem_1.default>
        <NestedMenuItem_1.default key="sync-sentiment-menu" style={{ opacity: 0.85 }} menuItems={[
            <MenuItem_1.default dense key="sync-survey-request" style={{ background: theme.palette.background.paper }}>
              <ListItemText_1.default primary="Survey Requested"/>
              <Switch_1.default size="small" color="primary" disabled={!authSession} onChange={(event, value) => {
                    dispatchUpdateAuth({ syncSurveyRequested: value });
                }} checked={Boolean(authSession && authSession.syncSurveyRequested)}/>
            </MenuItem_1.default>,
            <MenuItem_1.default dense key="check-for-sync-sentiment" style={{ background: theme.palette.background.paper }} onClick={() => dispatch(syncSentimentActions.checkIfSyncSentimentSurveyRequestedAction())}>
              Check for Survey Now
            </MenuItem_1.default>,
        ]}>
          Sync Sentiment Survey
        </NestedMenuItem_1.default>
        <Divider_1.default style={{ backgroundColor: theme.palette.background.elevated }}/>
        <NestedMenuItem_1.default key="QHelp-Menu" style={{ opacity: 0.85 }} menuItems={[
            <MenuItem_1.default dense key="upgrade" style={{ background: theme.palette.background.paper }} onClick={() => {
                    showQHelp('upgradeVersion', Object.assign(Object.assign({}, (0, utils_1.safeRefIn)(profile, ['product'])), { minBuildNumber: featureFlags.get('minWindowsBuildNumber') }));
                }}>
              Version Number Check (Windows)
            </MenuItem_1.default>,
            <MenuItem_1.default dense key="upgrade-MAC" style={{ background: theme.palette.background.paper }} onClick={() => {
                    showQHelp('upgradeVersion', Object.assign(Object.assign({}, (0, utils_1.safeRefIn)(profile, ['product'])), { clientType: 'MAC', minBuildNumber: featureFlags.get('minMacReleaseNumber') }));
                }}>
              Version Number Check (Mac)
            </MenuItem_1.default>,
            <MenuItem_1.default dense key="upgrade-windows-rev" style={{ background: theme.palette.background.paper }} onClick={() => showQHelp('windowsReviewed')}>
              Using Reviewed Column
            </MenuItem_1.default>,
        ]}>
          QHelp
        </NestedMenuItem_1.default>

        <Divider_1.default style={{ backgroundColor: theme.palette.background.elevated }}/>

        <MenuItem_1.default dense key="MCP-test-toggle">
          <ListItemText_1.default primary="MCP test mode"/>
          <Switch_1.default size="small" color="primary" onChange={(_event, value) => {
            setMcpTestMode(value);
            core_1.localPreferences.setMCPTestMode(value);
        }} checked={mcpTestMode}/>
        </MenuItem_1.default>

        <Divider_1.default style={{ backgroundColor: theme.palette.background.elevated }}/>

        <NestedMenuItem_1.default key="Reset-Menu" style={{ opacity: 0.85 }} menuItems={[
            <MenuItem_1.default dense key="clear-acc-prefs" style={{ background: theme.palette.background.paper }} onClick={(_event) => clearAccountPreferences()}>
              Clear Account Preferences
            </MenuItem_1.default>,
            <MenuItem_1.default dense key="clear-webapp-prefs" style={{ background: theme.palette.background.paper }} onClick={(_event) => clearWebAppPreferences()}>
              Clear Web App Preferences
            </MenuItem_1.default>,
            <MenuItem_1.default dense key="reset-windows-rev" style={{ background: theme.palette.background.paper }} onClick={(_event) => resetWindowsReviewedPreference()}>
              Reset Windows Reviewed Preference
            </MenuItem_1.default>,
            <MenuItem_1.default dense key="reset-windows-ver" style={{ background: theme.palette.background.paper }} onClick={() => (0, Main_1.resetVersionWarning)()}>
              Reset Windows Version Warning
            </MenuItem_1.default>,
        ]}>
          Reset
        </NestedMenuItem_1.default>

        <Divider_1.default style={{ backgroundColor: theme.palette.background.elevated }}/>
        <NestedMenuItem_1.default key="Log-Level-Menu" menuItems={[
            <MenuItem_1.default dense key="local-override" style={{ background: theme.palette.background.paper }}>
              <ListItemText_1.default primary="Local Override"/>
              <Switch_1.default size="small" color="primary" onChange={(event, value) => {
                    if (!value) {
                        core_1.localPreferences.removeItem('loggingLevel');
                        forceUpdate();
                    }
                }} checked={core_1.localPreferences.getItem('loggingLevel')}/>
            </MenuItem_1.default>,
            <Divider_1.default style={{ backgroundColor: theme.palette.background.elevated }}/>,
            ...Object.keys(core_1.loggerConfigurator.LogLevelsEnum).map((logLevelName) => (<MenuItem_1.default dense key={logLevelName} style={{ background: theme.palette.background.paper }} onClick={() => {
                    core_1.loggerConfigurator.storeLoggingLevel(core_1.loggerConfigurator.LogLevelsEnum[logLevelName]);
                    forceUpdate();
                }}>
                <Radio_1.default checked={core_1.loggerConfigurator.retrieveLoggingLevel() === core_1.loggerConfigurator.LogLevelsEnum[logLevelName]}/>
                {logLevelName}+
              </MenuItem_1.default>)),
            <Divider_1.default style={{ backgroundColor: theme.palette.background.elevated }}/>,
            <MenuItem_1.default dense key="debug-test" style={{ background: theme.palette.background.paper }} onClick={() => logger.debug('test loging: %s', 'debug')}>
              trigger debug logging
            </MenuItem_1.default>,
            <MenuItem_1.default dense key="log-test" style={{ background: theme.palette.background.paper }} onClick={() => logger.log('test logging: %s', 'log')}>
              trigger log logging
            </MenuItem_1.default>,
            <MenuItem_1.default dense key="info-test" style={{ background: theme.palette.background.paper }} onClick={() => logger.info('test logging: %s', 'info')}>
              trigger info log
            </MenuItem_1.default>,
            <MenuItem_1.default dense key="warn-test" style={{ background: theme.palette.background.paper }} onClick={() => logger.warn('test logging: %s', 'warn')}>
              trigger warn log
            </MenuItem_1.default>,
            <MenuItem_1.default dense key="error-test" style={{ background: theme.palette.background.paper }} onClick={() => logger.error('test logging: %s', 'error')}>
              trigger error log
            </MenuItem_1.default>,
            <MenuItem_1.default dense key="fatal-test" style={{ background: theme.palette.background.paper }} onClick={() => logger.fatal('test logging: %s', 'fatal')}>
              trigger fatal log
            </MenuItem_1.default>,
        ]}>
          Log level ({core_1.loggerConfigurator.retrieveLoggingLevel()})
        </NestedMenuItem_1.default>

        <Divider_1.default />

        <Divider_1.default />

        <ListItem_1.default key="sandbox-toggle">
          <ListItemText_1.default primary="Sandbox"/>
          <ListItemSecondaryAction_1.default>
            <Switch_1.default size="small" color="primary" onChange={(_event, value) => {
            sessionStorageEx.setSandbox(value);
            forceUpdate();
        }} checked={sessionStorageEx.getSandbox()}/>
          </ListItemSecondaryAction_1.default>
        </ListItem_1.default>

        <ListItem_1.default key="render-count">
          <ListItemText_1.default primary="Render Count"/>
          <ListItemSecondaryAction_1.default>
            <Switch_1.default size="small" color="primary" onChange={(_event, value) => {
            core_1.localPreferences.setItem('render-count', value);
            forceUpdate();
        }} checked={(_l = core_1.localPreferences.getItem('render-count')) !== null && _l !== void 0 ? _l : true}/>
          </ListItemSecondaryAction_1.default>
        </ListItem_1.default>

        <ListItem_1.default key="render-count">
          <ListItemText_1.default primary="Dark Theme"/>
          <ListItemSecondaryAction_1.default>
            <Switch_1.default size="small" color="primary" onChange={(_event, value) => {
            localStorage.setItem('theme', value ? 'dark' : 'light');
            setDatasetPreference({
                theme: value ? 'dark' : 'light',
            });
        }} checked={datasetPreferences.theme === 'dark'}/>
          </ListItemSecondaryAction_1.default>
        </ListItem_1.default>        

        <Divider_1.default />

        <MenuItem_1.default dense onClick={() => logger.debug('current DB state:\n', redux_store_1.default === null || redux_store_1.default === void 0 ? void 0 : redux_store_1.default.getState())}>
          Dump DB to console
        </MenuItem_1.default>

        <Divider_1.default />

        <MenuItem_1.default dense key="hide-dev-menu" onClick={() => {
            toggleDevMenu(false);
            toggleMenu(false);
        }}>
          Hide Dev Menu
        </MenuItem_1.default>

        <Divider_1.default />

        <MenuItem_1.default dense key="test-toggle" onClick={onTest}>
          Test
        </MenuItem_1.default>
      </Menu_1.default>
    </div>);
};
exports.default = (0, compose_1.default)((0, QPreferences_1.default)(), (0, QDialogs_1.default)(), (0, QHelp_1.default)(), react_1.withTheme)((0, mui_1.withStyles)(DevMenu, styles));
/////////
